// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-node_modules_css-loader_dist_runtime_api_js-node_modules_css-loader_dist_runtime_getU-bc5466"], () => (__webpack_require__("./holotwin/app/index.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
